import { render, staticRenderFns } from "./documentos_proveedor.vue?vue&type=template&id=4183f961&"
import script from "./documentos_proveedor.vue?vue&type=script&lang=js&"
export * from "./documentos_proveedor.vue?vue&type=script&lang=js&"
import style0 from "./documentos_proveedor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports